export * from './panel-settings-products.descriptor';
export * from './panel-settings-products-edit-prices.descriptor';
export * from './panel-settings-products-add-edit-component.descriptor';
